export const getBaseDomain = window.location.hostname.split('.').slice(-2).join('.');
